import React, {
  useEffect,
} from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Spinner,
} from 'web-components';

import NoInvoices from './NoInvoices';
import InvoiceList from './InvoiceList';

const mapState = (state => ({
  invoices: coreSelectors.getInvoices(state),
  profileId: coreSelectors.getProfile('id')(state),
  getInvoicesState: coreSelectors.getPaymentRequestsState(
    'getInvoicesState',
  )(state),
}));

const PaymentsInvoices = () => {
  const {
    invoices,
    profileId,
    getInvoicesState,
  } = useSelector(mapState, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestInvoices({
        qs: {
          client_id: profileId,
          sort_direction: 'DESC',
        },
      }),
    );
  }, []);

  if (getInvoicesState !== 'success') {
    return (
      <Spinner
        message="Loading invoices..."
      />
    );
  }

  console.log('invoices', invoices);

  return invoices.length > 0
    ? <InvoiceList invoices={invoices} />
    : <NoInvoices />;
};

export default PaymentsInvoices;
